import useAppDispatch from "../../redux/base/useAppDispatch";
import { useEffect, useState } from "react";
import { AsyncCallArgs, useAsyncCall } from "@duosoftbg/nacid-components";
import { addViewObject, removeObject } from "../../../store/redux/slice/ViewData/viewDataPage";

type ViewDataObjectControlProps = {
  viewType: string;
  serviceFn: any;
};

const useViewDataObjectControl = ({ viewType, serviceFn }: ViewDataObjectControlProps) => {
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const { asyncCall } = useAsyncCall();

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: serviceFn,
      onSuccess: (response) => {
        const payload = { viewType, data: response };
        dispatch(addViewObject(payload));
        setLoading(false);
      },
      onError: () => {
        setNotFound(true);
        setLoading(false);
      },
    };
    asyncCall(asyncCallArgs);

    return () => {
      dispatch(removeObject());
    };
  }, [asyncCall, dispatch, serviceFn, viewType]);

  return { isLoading, notFound };
};

export default useViewDataObjectControl;
